import { CHATBOT_TOKEN_USER } from '../utils/constants';

const readCookieValue = (cookieName) => {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
        const trimmedCookie = cookie.trim();
        const index = trimmedCookie.indexOf('=');
        if (index > -1) {
            const name = trimmedCookie.substring(0, index);
            const value = trimmedCookie.substring(index + 1);
            if (name === cookieName) {
                return decodeURIComponent(value);
            }
        }
    }
    return null;
};

export const getTokenUserFromCookieChatbot = () => readCookieValue(CHATBOT_TOKEN_USER);

// Reads the `provider` cookie set by the host site (e.g. Felipe) and forwards it
// to the backend so it can be relayed as the `x-provider` header in the
// chatbot-referred API call. Returns null when the cookie is missing or HttpOnly.
export const getProviderCookieChatbot = () => readCookieValue('provider');
